<script setup>

  const props = defineProps({
    filtro: Object
  })

  // Construimos el array de números 
  const options = [];
  for(let i = parseFloat(props.filtro.integer_values.min); i<= parseFloat(props.filtro.integer_values.max); i+=parseFloat(props.filtro.integer_values.salto)) {
    options.push(i);
  }
</script>

<template>
  <div class="w-full my-3 flex space-x-4 items-center border-b pb-4">
    <div class="w-3/12 font-bold text-right">{{ filtro.nombre }}</div>
    <div class="w-9/12">
      <select 
          v-model="filtro.value"
          :class="{ 'error-validate' : filtro.error }" 
          :name="'filtros_default['+filtro.nombre_bd+']'" :id="'filtros_default_'+filtro.nombre_bd" class="select-f">
          <option value="">--</option>
          <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
      </select>
    </div>
  </div>
</template>

<style lang="scss">
  .error-validate {
    border: 1px solid #CC0000;
  }
</style>